import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3cdec288")

_pushScopeId("data-v-3cdec288")
const _hoisted_1 = { class: "apply-content mt-8" }
const _hoisted_2 = { class: "title-apply mt-4" }
const _hoisted_3 = { class: "flex items-center mb-6" }
const _hoisted_4 = {
  key: 1,
  class: "cp-icon-user-circle mr-4",
  style: {"font-size":"2.6rem"}
}
const _hoisted_5 = { class: "mx-4" }
const _hoisted_6 = { class: "text-xs text-gray-600" }
const _hoisted_7 = { class: "font-bold text-sm" }
const _hoisted_8 = { class: "mr-4" }
const _hoisted_9 = { class: "text-xs text-gray-600" }
const _hoisted_10 = { class: "text-sm" }
const _hoisted_11 = {
  key: 2,
  class: "mr-4"
}
const _hoisted_12 = { class: "text-xs text-gray-600" }
const _hoisted_13 = { class: "text-sm" }
const _hoisted_14 = {
  key: 3,
  class: "mr-4"
}
const _hoisted_15 = { class: "text-xs text-gray-600" }
const _hoisted_16 = { class: "text-sm" }
const _hoisted_17 = { class: "title-apply" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = {
  key: 1,
  class: "cp-icon-user-circle mr-4 cursor-default",
  style: {"font-size":"2.6rem"}
}
const _hoisted_21 = { class: "text-xs text-gray-600" }
const _hoisted_22 = { class: "font-bold text-sm" }
const _hoisted_23 = { class: "mr-4" }
const _hoisted_24 = {
  key: 0,
  class: "text-xs text-gray-600"
}
const _hoisted_25 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_26 = {
  key: 1,
  class: "flex items-center mb-6"
}
const _hoisted_27 = {
  key: 1,
  class: "cp-icon-user-circle mr-4 cursor-default",
  style: {"font-size":"2.6rem"}
}
const _hoisted_28 = { class: "text-xs text-gray-600" }
const _hoisted_29 = { class: "font-bold text-sm" }
const _hoisted_30 = { class: "mr-4" }
const _hoisted_31 = {
  key: 0,
  class: "text-xs text-gray-600"
}
const _hoisted_32 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_33 = { key: 1 }
const _hoisted_34 = {
  key: 0,
  class: ""
}
const _hoisted_35 = { class: "text-xs text-gray-600" }
const _hoisted_36 = { class: "font-bold text-sm" }
const _hoisted_37 = { class: "mr-4" }
const _hoisted_38 = {
  key: 0,
  class: "text-xs text-gray-600"
}
const _hoisted_39 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_40 = {
  key: 0,
  class: "flex"
}
const _hoisted_41 = {
  key: 0,
  class: "mr-4"
}
const _hoisted_42 = { class: "text-xs text-gray-600" }
const _hoisted_43 = { class: "text-sm" }
const _hoisted_44 = {
  key: 1,
  class: "mr-4"
}
const _hoisted_45 = { class: "text-xs text-gray-600" }
const _hoisted_46 = { class: "text-sm" }
const _hoisted_47 = { class: "flex items-center approve-status approve justify-center" }
const _hoisted_48 = { class: "mr-2" }
const _hoisted_49 = { class: "flex items-center approve-status pending justify-center" }
const _hoisted_50 = { class: "mr-2" }
const _hoisted_51 = { class: "flex items-center approve-status reject justify-center" }
const _hoisted_52 = { class: "mr-2" }
const _hoisted_53 = {
  key: 1,
  class: "flex items-center mb-6"
}
const _hoisted_54 = {
  key: 1,
  class: "cp-icon-user-circle mr-4",
  style: {"font-size":"2.6rem"}
}
const _hoisted_55 = { class: "text-xs text-gray-600" }
const _hoisted_56 = { class: "font-bold text-sm" }
const _hoisted_57 = { class: "mr-4" }
const _hoisted_58 = {
  key: 0,
  class: "text-xs text-gray-600"
}
const _hoisted_59 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_60 = {
  key: 2,
  class: "flex"
}
const _hoisted_61 = {
  key: 0,
  class: "mr-4"
}
const _hoisted_62 = { class: "text-xs text-gray-600" }
const _hoisted_63 = { class: "text-sm" }
const _hoisted_64 = {
  key: 1,
  class: "mr-4"
}
const _hoisted_65 = { class: "text-xs text-gray-600" }
const _hoisted_66 = { class: "text-sm" }
const _hoisted_67 = { class: "flex items-center approve-status approve justify-center" }
const _hoisted_68 = { class: "mr-2" }
const _hoisted_69 = { class: "flex items-center approve-status pending justify-center" }
const _hoisted_70 = { class: "mr-2" }
const _hoisted_71 = { class: "flex items-center approve-status reject justify-center" }
const _hoisted_72 = { class: "mr-2" }
const _hoisted_73 = {
  key: 0,
  class: ""
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Avatar = _resolveComponent("Avatar")
  const _component_ApproveIcon = _resolveComponent("ApproveIcon")
  const _component_PendingIcon = _resolveComponent("PendingIcon")
  const _component_RejectIcon = _resolveComponent("RejectIcon")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.t('dailyAttendanceHeaders.apply')), 1),
    _createVNode("div", _hoisted_3, [
      (_ctx.checkAvatar(_ctx.employeeInfo.pp_employee_id))
        ? (_openBlock(), _createBlock(_component_Avatar, {
            key: 0,
            src: _ctx.checkAvatar(_ctx.employeeInfo.pp_employee_id)[0]?.profileFile,
            name: _ctx.checkAvatar(_ctx.employeeInfo.pp_employee_id)[0]?.nameFaceImage,
            id: _ctx.checkAvatar(_ctx.employeeInfo.pp_employee_id)[0]?.id,
            cursor: "default"
          }, null, 8, ["src", "name", "id"]))
        : (_openBlock(), _createBlock("span", _hoisted_4)),
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, _toDisplayString(_ctx.t('fullName')), 1),
        _createVNode("div", _hoisted_7, _toDisplayString(_ctx.employeeInfo.name), 1)
      ]),
      _createVNode("div", _hoisted_8, [
        _createVNode("div", _hoisted_9, _toDisplayString(_ctx.t('deploy')), 1),
        _createVNode("div", _hoisted_10, _toDisplayString(_ctx.employeeInfo.unit_name), 1)
      ]),
      (_ctx.workingStyleName)
        ? (_openBlock(), _createBlock("div", _hoisted_11, [
            _createVNode("div", _hoisted_12, _toDisplayString(_ctx.t('attendanceDataHeaders.workingStyleName')), 1),
            _createVNode("div", _hoisted_13, _toDisplayString(_ctx.workingStyleName), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.createdAt && !_ctx.isWaitingAllowDelete)
        ? (_openBlock(), _createBlock("div", _hoisted_14, [
            _createVNode("div", _hoisted_15, _toDisplayString(_ctx.t('applicationDateFind')), 1),
            _createVNode("div", _hoisted_16, _toDisplayString(_ctx.createdAt), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listApprove, (item, index) => {
      return (_openBlock(), _createBlock("div", { key: index }, [
        _createVNode("div", _hoisted_17, _toDisplayString(index) + _toDisplayString(_ctx.t('primaryApprovalFlow')), 1),
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(item, (itemRow, indexRow) => {
          return (_openBlock(), _createBlock("div", { key: indexRow }, [
            (itemRow.application_approval_applies)
              ? (_openBlock(), _createBlock("div", _hoisted_18, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(itemRow.application_approval_applies, (users, indexUser) => {
                    return (_openBlock(), _createBlock("div", {
                      class: "",
                      key: indexUser
                    }, [
                      (users.employees_one_role)
                        ? (_openBlock(), _createBlock("div", _hoisted_19, [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(users.employees_one_role, (itemRole, idRole) => {
                              return (_openBlock(), _createBlock("div", {
                                class: "flex items-center mb-6",
                                key: idRole
                              }, [
                                (_ctx.checkAvatar(itemRole.pp_employee_id))
                                  ? (_openBlock(), _createBlock(_component_Avatar, {
                                      key: 0,
                                      src: _ctx.checkAvatar(itemRole.pp_employee_id)[0]?.profileFile,
                                      name: _ctx.checkAvatar(itemRole.pp_employee_id)[0]?.nameFaceImage,
                                      id: _ctx.checkAvatar(itemRole.pp_employee_id)[0]?.id,
                                      cursor: "default"
                                    }, null, 8, ["src", "name", "id"]))
                                  : (_openBlock(), _createBlock("span", _hoisted_20)),
                                _createVNode("div", {
                                  class: ["mr-4", _ctx.checkAvatar(itemRole.pp_employee_id) ? 'ml-4' : '']
                                }, [
                                  _createVNode("div", _hoisted_21, _toDisplayString(_ctx.t('fullName')), 1),
                                  _createVNode("div", _hoisted_22, _toDisplayString(itemRole.employee_name), 1)
                                ], 2),
                                _createVNode("div", _hoisted_23, [
                                  (itemRole.unit_name)
                                    ? (_openBlock(), _createBlock("div", _hoisted_24, _toDisplayString(_ctx.t('deploy')), 1))
                                    : _createCommentVNode("", true),
                                  (itemRole.unit_name)
                                    ? (_openBlock(), _createBlock("div", _hoisted_25, _toDisplayString(itemRole.unit_name || ''), 1))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                            }), 128))
                          ]))
                        : (_openBlock(), _createBlock("div", _hoisted_26, [
                            (_ctx.checkAvatar(users.pp_employee_id))
                              ? (_openBlock(), _createBlock(_component_Avatar, {
                                  key: 0,
                                  src: _ctx.checkAvatar(users.pp_employee_id)[0]?.profileFile,
                                  name: _ctx.checkAvatar(users.pp_employee_id)[0]?.nameFaceImage,
                                  id: _ctx.checkAvatar(users.pp_employee_id)[0]?.id,
                                  cursor: "default"
                                }, null, 8, ["src", "name", "id"]))
                              : (_openBlock(), _createBlock("span", _hoisted_27)),
                            _createVNode("div", {
                              class: ["mr-4", _ctx.checkAvatar(users.pp_employee_id) ? 'ml-4' : '']
                            }, [
                              _createVNode("div", _hoisted_28, _toDisplayString(_ctx.t('fullName')), 1),
                              _createVNode("div", _hoisted_29, _toDisplayString(users.employee_name), 1)
                            ], 2),
                            _createVNode("div", _hoisted_30, [
                              (users.unit_name)
                                ? (_openBlock(), _createBlock("div", _hoisted_31, _toDisplayString(_ctx.t('deploy')), 1))
                                : _createCommentVNode("", true),
                              (users.unit_name)
                                ? (_openBlock(), _createBlock("div", _hoisted_32, _toDisplayString(users.unit_name || ''), 1))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                    ]))
                  }), 128))
                ]))
              : (itemRow.application_approval_history_applies)
                ? (_openBlock(), _createBlock("div", _hoisted_33, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(itemRow.application_approval_history_applies, (users, indexUser) => {
                      return (_openBlock(), _createBlock("div", {
                        class: "flex items-center mb-6",
                        key: indexUser
                      }, [
                        (users.employees_one_role.length)
                          ? (_openBlock(), _createBlock("div", _hoisted_34, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(users.employees_one_role, (roleName, roleId) => {
                                return (_openBlock(), _createBlock("div", {
                                  class: "flex items-center mb-6",
                                  key: roleId
                                }, [
                                  _createVNode(_component_Avatar, {
                                    src: _ctx.checkAvatar(roleName.pp_employee_id)[0]?.profileFile,
                                    name: _ctx.checkAvatar(roleName.pp_employee_id)[0]?.nameFaceImage,
                                    id: _ctx.checkAvatar(roleName.pp_employee_id)[0]?.id,
                                    cursor: "default"
                                  }, null, 8, ["src", "name", "id"]),
                                  _createVNode("div", {
                                    class: ["mr-4", _ctx.checkAvatar(roleName.pp_employee_id) ? 'ml-4' : '']
                                  }, [
                                    _createVNode("div", _hoisted_35, _toDisplayString(_ctx.t('fullName')), 1),
                                    _createVNode("div", _hoisted_36, _toDisplayString(roleName.employee_name), 1)
                                  ], 2),
                                  _createVNode("div", _hoisted_37, [
                                    (roleName.unit_name)
                                      ? (_openBlock(), _createBlock("div", _hoisted_38, _toDisplayString(_ctx.t('deploy')), 1))
                                      : _createCommentVNode("", true),
                                    (roleName.unit_name)
                                      ? (_openBlock(), _createBlock("div", _hoisted_39, _toDisplayString(roleName.unit_name || ''), 1))
                                      : _createCommentVNode("", true)
                                  ]),
                                  (
                    itemRow.approved_employee_id === roleName.pp_employee_id
                  )
                                    ? (_openBlock(), _createBlock("div", _hoisted_40, [
                                        (itemRow.submission_date)
                                          ? (_openBlock(), _createBlock("div", _hoisted_41, [
                                              _createVNode("div", _hoisted_42, _toDisplayString(_ctx.t('correspondenceDateEndTime')), 1),
                                              _createVNode("div", _hoisted_43, _toDisplayString(itemRow.submission_date), 1)
                                            ]))
                                          : _createCommentVNode("", true),
                                        (itemRow.reason)
                                          ? (_openBlock(), _createBlock("div", _hoisted_44, [
                                              _createVNode("div", _hoisted_45, _toDisplayString(_ctx.t('message')), 1),
                                              _createVNode("div", _hoisted_46, _toDisplayString(itemRow.reason), 1)
                                            ]))
                                          : _createCommentVNode("", true),
                                        _withDirectives(_createVNode("div", _hoisted_47, [
                                          _createVNode("div", _hoisted_48, [
                                            _createVNode(_component_ApproveIcon)
                                          ]),
                                          _createTextVNode(" " + _toDisplayString(_ctx.t('approveStatus')), 1)
                                        ], 512), [
                                          [_vShow, itemRow.approval_status === _ctx.STATUS.DONE]
                                        ]),
                                        _withDirectives(_createVNode("div", _hoisted_49, [
                                          _createVNode("div", _hoisted_50, [
                                            _createVNode(_component_PendingIcon)
                                          ]),
                                          _createTextVNode(" " + _toDisplayString(_ctx.t('approvalPending')), 1)
                                        ], 512), [
                                          [_vShow, itemRow.approval_status === _ctx.STATUS.PENDING]
                                        ]),
                                        _withDirectives(_createVNode("div", _hoisted_51, [
                                          _createVNode("div", _hoisted_52, [
                                            _createVNode(_component_RejectIcon)
                                          ]),
                                          _createTextVNode(" " + _toDisplayString(_ctx.t('remandFind')), 1)
                                        ], 512), [
                                          [_vShow, itemRow.approval_status === _ctx.STATUS.REJECT]
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128))
                            ]))
                          : (_openBlock(), _createBlock("div", _hoisted_53, [
                              (_ctx.checkAvatar(users.pp_employee_id))
                                ? (_openBlock(), _createBlock(_component_Avatar, {
                                    key: 0,
                                    src: _ctx.checkAvatar(users.pp_employee_id)[0]?.profileFile,
                                    name: _ctx.checkAvatar(users.pp_employee_id)[0]?.nameFaceImage,
                                    id: _ctx.checkAvatar(users.pp_employee_id)[0]?.id,
                                    cursor: "default"
                                  }, null, 8, ["src", "name", "id"]))
                                : (_openBlock(), _createBlock("span", _hoisted_54)),
                              _createVNode("div", {
                                class: ["mr-4", _ctx.checkAvatar(users.pp_employee_id) ? 'ml-4' : '']
                              }, [
                                _createVNode("div", _hoisted_55, _toDisplayString(_ctx.t('fullName')), 1),
                                _createVNode("div", _hoisted_56, _toDisplayString(users.employee_name), 1)
                              ], 2),
                              _createVNode("div", _hoisted_57, [
                                (users.unit_name)
                                  ? (_openBlock(), _createBlock("div", _hoisted_58, _toDisplayString(_ctx.t('deploy')), 1))
                                  : _createCommentVNode("", true),
                                (users.unit_name)
                                  ? (_openBlock(), _createBlock("div", _hoisted_59, _toDisplayString(users.unit_name || ''), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              (itemRow.approved_employee_id === users.pp_employee_id)
                                ? (_openBlock(), _createBlock("div", _hoisted_60, [
                                    (itemRow.submission_date)
                                      ? (_openBlock(), _createBlock("div", _hoisted_61, [
                                          _createVNode("div", _hoisted_62, _toDisplayString(_ctx.t('correspondenceDateEndTime')), 1),
                                          _createVNode("div", _hoisted_63, _toDisplayString(itemRow.submission_date), 1)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (itemRow.reason)
                                      ? (_openBlock(), _createBlock("div", _hoisted_64, [
                                          _createVNode("div", _hoisted_65, _toDisplayString(_ctx.t('message')), 1),
                                          _createVNode("div", _hoisted_66, _toDisplayString(itemRow.reason), 1)
                                        ]))
                                      : _createCommentVNode("", true),
                                    _withDirectives(_createVNode("div", _hoisted_67, [
                                      _createVNode("div", _hoisted_68, [
                                        _createVNode(_component_ApproveIcon)
                                      ]),
                                      _createTextVNode(" " + _toDisplayString(_ctx.t('approveStatus')), 1)
                                    ], 512), [
                                      [_vShow, itemRow.approval_status === _ctx.STATUS.DONE]
                                    ]),
                                    _withDirectives(_createVNode("div", _hoisted_69, [
                                      _createVNode("div", _hoisted_70, [
                                        _createVNode(_component_PendingIcon)
                                      ]),
                                      _createTextVNode(" " + _toDisplayString(_ctx.t('approvalPending')), 1)
                                    ], 512), [
                                      [_vShow, itemRow.approval_status === _ctx.STATUS.PENDING]
                                    ]),
                                    _withDirectives(_createVNode("div", _hoisted_71, [
                                      _createVNode("div", _hoisted_72, [
                                        _createVNode(_component_RejectIcon)
                                      ]),
                                      _createTextVNode(" " + _toDisplayString(_ctx.t('remandFind')), 1)
                                    ], 512), [
                                      [_vShow, itemRow.approval_status === _ctx.STATUS.REJECT]
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
          ]))
        }), 128))
      ]))
    }), 128)),
    (!_ctx.isWaitingAllowDelete)
      ? (_openBlock(), _createBlock("div", _hoisted_73, [
          _withDirectives(_createVNode("div", { class: "title-apply" }, _toDisplayString(_ctx.t('completion')), 513), [
            [_vShow, _ctx.status === _ctx.APPLICATION_STATUS_TYPE.FINISHED]
          ]),
          _withDirectives(_createVNode("div", { class: "title-apply" }, _toDisplayString(_ctx.t('remandFind')), 513), [
            [_vShow, _ctx.status === _ctx.APPLICATION_STATUS_TYPE.REJECTED]
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
})